import { FC, ReactNode } from "react";
import { Box } from "@mui/material";

interface IModernGridInfo {
  children: ReactNode;
  columns?: number;
}

export const ModernGridInfo: FC<IModernGridInfo> = ({ children, columns = 2 }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: `repeat(${Math.min(columns, 2)}, 1fr)`,
          md: `repeat(${columns}, 1fr)`,
        },
        gap: { xs: 2, sm: 2.5 },
      }}
    >
      {children}
    </Box>
  );
};
